import styled from '@emotion/styled'

const StyledButton = styled.button`
  padding: ${(props) => {
    const { size } = props
    if (size === 'sm') {
      return '.125rem .5rem'
    }
    if (size === 'lg') {
      return '.5rem 1.5rem'
    }
    return '.3125rem 1rem'
  }};
  font-size: ${(props) => {
    const { size } = props
    if (size === 'sm') {
      return '.75rem'
    }
    if (size === 'lg') {
      return '1rem'
    }
    return '.875rem'
  }};
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  box-sizing: border-box;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-radius: var(--button-border-radius);
  border-width: 1px;
  border-style: solid;
  border-color: ${(props) => {
    const { borderColor } = props
    return borderColor
  }};
  :hover {
    background-color: ${(props) => {
      const { showType, opacityType, $stroke } = props
      return (
        opacityType === 'full' &&
        !$stroke &&
        showType &&
        `var(--ow-color-${showType}-600)`
      )
    }};
    border-width: 1px;
  }
  :disabled {
    background-color: ${(props) => {
      const { showType, opacityType } = props
      return (
        opacityType === 'full' && showType && `var(--ow-color-${showType}-300)`
      )
    }};
  }
`

export default StyledButton
